<template>
    <div>
        <button class="btn btn-danger" @click="openModal('delete-serie-modal')">
            <i class="fas fa-trash-alt"></i> Delete
        </button>
        <modal id="delete-serie-modal" color="red">
            <template slot="title">Delete Serie</template>
            <template slot="body">
                <p>Do you really want to delete this Series?</p>
                <small class="text-danger">All videos on this series will be deleted.</small>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-default" @click="closeModal('delete-serie-modal')">Cancel</button>
                <button type="button" class="btn btn-danger" :disabled="form.isSubmitted" @click="save()" >Delete</button>
            </template>
        </modal>
    </div>
</template>

<script>
    export default {

        props: {
            serie: {
                type: Object,
                required: true,
            },
        },

        data(){
            return {
                form: new Form({})
            }
        },

        methods: {
            save(){
                this.form.delete(`/training/series/${this.serie.slug}`).then(response => {
                    this.redirectTo(`/training/series`);
                });
            }
        }
    }
</script>
